// extracted by mini-css-extract-plugin
export var benefits = "benefitsList-module--benefits--1Zgkk";
export var jsAnimInit = "benefitsList-module--jsAnimInit--Nph0a";
export var title = "benefitsList-module--title--2lYcX";
export var text = "benefitsList-module--text--22EWQ";